/* ───────────────────────────────────────────────────────────────────────────
   O16 — puts Contribe's PDP badge in the copy of the page the shopper sees.

   THE PROBLEM
   This theme renders the product section TWICE: once inside
   .main-product-desktop-section-wrapper and once inside
   .main-product-mobile-section-wrapper (sections/main-product.liquid). CSS
   shows exactly one of them per viewport. Both copies therefore contain a
   .o16-pdp-reassurance block, and Contribe's plugin injects into the FIRST
   match it finds, which is always the desktop one.

   On desktop that is correct and the badge measures 568x63. On mobile the
   badge is inside the hidden wrapper and measures 0x0 — invisible to roughly
   80% of this store's traffic, which arrives through the Instagram in-app
   browser. Verified on DEV 2026-09-09.

   THE FIX HERE
   Move the badge element into whichever .o16-pdp-reassurance is actually
   visible, and keep doing so on resize and on variant re-render. We move
   rather than clone: a second <contribe-badge> would register a second
   impression with their API and could double count.

   This is a shim, not the real repair. The right fix is for Contribe to
   inject into every match rather than the first; when they do, this file can
   go. It is written to be harmless in that case — if a badge is already
   inside the visible copy, it does nothing.
─────────────────────────────────────────────────────────────────────────── */
(function () {
  'use strict';

  var BADGE = 'contribe-badge';
  var ANCHOR = '.o16-pdp-reassurance';

  function isVisible(el) {
    if (!el) return false;
    var r = el.getBoundingClientRect();
    return r.width > 0 && r.height > 0;
  }

  /** The anchor in the copy of the page currently on screen. */
  function visibleAnchor() {
    var anchors = document.querySelectorAll(ANCHOR);
    for (var i = 0; i < anchors.length; i += 1) {
      if (isVisible(anchors[i])) return anchors[i];
    }
    return null;
  }

  function place() {
    var badge = document.querySelector(BADGE);
    if (!badge) return false;
    var anchor = visibleAnchor();
    if (!anchor) return false;
    // Already in the right copy: leave it alone. This is also what makes the
    // file a no-op once Contribe injects into every match themselves.
    if (anchor.parentElement && anchor.parentElement.contains(badge)) return true;
    // Same position their own config asks for: immediately before the block.
    anchor.parentElement.insertBefore(badge, anchor);
    return true;
  }

  // Their plugin loads asynchronously, so wait for the element to appear
  // rather than guessing a delay. Stops watching once it has been placed.
  var observer = new MutationObserver(function () {
    if (place()) { observer.disconnect(); armResize(); }
    wireTrigger();
  });

  var resizeArmed = false;
  function armResize() {
    if (resizeArmed) return;
    resizeArmed = true;
    var t = null;
    window.addEventListener('resize', function () {
      clearTimeout(t);
      t = setTimeout(place, 200);
    });
    // A variant switch re-renders the section, which can drop the badge back
    // into the desktop copy. Same event the rest of this theme listens on.
    document.addEventListener('variant:change', function () { setTimeout(place, 300); });
  }

  /* THE BADGE HAS NO TRIGGER OF ITS OWN.
     <contribe-badge> is purely presentational: its prototype has render,
     renderInfoBlock, renderProgressBlock and nothing that opens anything,
     while every element inside its shadow root carries cursor:pointer, so it
     reads as clickable to a shopper who then gets nothing. <contribe-modal>
     is fully built and works the moment its own show() is called — verified
     on DEV 2026-09-09, the explanation panel renders complete.

     So we connect the two. This is the second half of the shim and the same
     caveat applies: it belongs in Contribe's plugin, not here. Written
     defensively — if they ever wire it themselves we would double fire, so
     the listener bails out when the modal is already open. */
  var wired = false;
  function wireTrigger() {
    if (wired) return;
    var badge = document.querySelector(BADGE);
    var modal = document.querySelector('contribe-modal');
    if (!badge || !modal || typeof modal.show !== 'function') return;
    wired = true;
    badge.addEventListener('click', function () {
      if (modal.open) return;
      try { modal.show(); } catch (e) {
        // Never let a third party component's error break the product page.
      }
    });
  }

  function start() {
    if (place()) { armResize(); wireTrigger(); return; }
    observer.observe(document.body, { childList: true, subtree: true });
    // Give up watching after a while rather than observing the whole document
    // for the life of the page.
    setTimeout(function () { observer.disconnect(); }, 20000);
    armResize();
  }


  /* OUR LINE OPENS THEIR PANEL (owner 2026-09-09).
     Contribe's badge is hidden by CSS and replaced by a plain sentence in
     the site's voice, but their <contribe-modal> is still the explanation we
     want to show, and it opens correctly the moment its own show() is
     called. So the link calls it. The badge stays in the DOM because it is
     what their plugin builds the modal alongside. */
  document.addEventListener('click', function (e) {
    var link = e.target && e.target.closest && e.target.closest('[data-o16-pdp-cause-open]');
    if (!link) return;
    var modal = document.querySelector('contribe-modal');
    if (!modal || typeof modal.show !== 'function' || modal.open) return;
    try { modal.show(); } catch (err) {
      // A third party component must never break the product page.
    }
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
